import useThemePreference from "@/hooks/useThemePreference";
import {ReactElement} from "react";

function AuthHeaderLogo(): ReactElement {
    const { getThemedImageUrl } = useThemePreference();
    return (
        <div className="auth-header-logo">
            <img
                src="/images/devourplay-logo2.png"
                alt="DevourPlay Logo"
            />
        </div>
    );
}

export default AuthHeaderLogo;
